import e164ify from "./e164";

export default function mobileLogin(mobileNumber) {
    return e164ify(mobileNumber).replace(/^\+/, '') + '@phonethru.com'
};
